import { gql } from "@apollo/client";

export const listHistoryLogs = gql`
  query listHistoryLogs($filter: HistoryLogFilterInput, $offset: Int, $limit: Int) {
    listHistoryLogs(filter: $filter, offset: $offset, limit: $limit) {
      total
      items {
        eventDate
        note
        changeMade
        programId
        entity {
          id
          type
          subType
          operation
          data
          name
        }
        user {
          gpid
          userName
        }
        difference {
          field
          from
          to
        }
      }
    }
  }
`;
